import React from 'react';
import { useLoadScript, GoogleMap, Marker, Polyline } from '@react-google-maps/api';
import { LoadingSpinner } from '@common/LoadingSpinner';

// Only load required libraries
const libraries = ['places', 'geometry'];

const mapContainerStyle = {
  width: '100%',
  height: '100%'
};

const defaultCenter = {
  lat: 45.5017,
  lng: -73.5673
};

export const ProfileMap = ({ points = [], currentLocation, isRecording }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    libraries,
    preventGoogleFontsLoading: true
  });

  if (loadError) {
    return (
      <div className="h-[452px] rounded-lg overflow-hidden">
        <div className="h-[452px] flex items-center justify-center">
          <div className="bg-red-500/10 text-red-500 p-4 rounded-lg">
            Error loading Google Maps
          </div>
        </div>
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div className="h-[452px] rounded-lg overflow-hidden">
        <div className="h-[452px] flex items-center justify-center">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  // Only define map options after Maps API is loaded
  const mapOptions = {
    disableDefaultUI: true,
    zoomControl: true,
    mapTypeControl: true,
    mapTypeControlOptions: {
      style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: window.google.maps.ControlPosition.TOP_RIGHT
    },
    styles: [
      {
        featureType: 'poi',
        stylers: [{ visibility: 'off' }]
      }
    ]
  };

  return (
    <div className="h-[452px] rounded-lg overflow-hidden">
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={18}
        center={currentLocation || defaultCenter}
        options={mapOptions}
      >
        {/* Track Line */}
        {points.length > 1 && (
          <Polyline
            path={points.map(p => ({ lat: p.latitude, lng: p.longitude }))}
            options={{
              strokeColor: '#3B82F6',
              strokeWeight: 3,
              strokeOpacity: 1,
              geodesic: true
            }}
          />
        )}

        {/* Current Location */}
        {currentLocation && (
          <Marker
            position={currentLocation}
            icon={{
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: 8,
              fillColor: isRecording ? '#EF4444' : '#3B82F6',
              fillOpacity: 1,
              strokeWeight: 2,
              strokeColor: '#FFFFFF'
            }}
          />
        )}
      </GoogleMap>
    </div>
  );
};